export enum ChargePatientModalType {
  CHARGE = 'charge',
  REFUND = 'refund',
}

export enum ChargePatientRadioOptions {
  CHARGE = 'Charge',
  REFUND = 'Refund',
}
